import { ReactElement } from 'react';
import axios from '../../utils/axios';
import { BsBicycle } from 'react-icons/bs';

interface DownloadFITButtonProps {
  runId: string;
}

export default function DownloadFITButton({ runId }: DownloadFITButtonProps): ReactElement {
  const handleDownloadFIT = async (): Promise<void> => {
    try {
      const response = await axios.get(`/runs/${runId}?scope=fit`, { responseType: 'blob' });
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);
      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      const filename_parts = response.headers['content-disposition']?.split('filename=');
      const filename = filename_parts?.length === 2 ? filename_parts[1] : 'run.fit';
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } catch (error) {
      console.error('Error downloading FIT:', error);
    }
  };

  return (
    <button
      onClick={handleDownloadFIT}
      className="cr-flex cr-items-center cr-gap-x-1.5 cr-whitespace-nowrap cr-rounded-md cr-bg-gray-200 cr-px-3 cr-py-1.5 cr-text-sm cr-font-semibold cr-text-blue-900/70 cr-no-underline cr-transition-colors cr-duration-200 hover:cr-bg-cirrusBlue-50 hover:cr-text-blue-900"
    >
      <BsBicycle className="cr-h-4 cr-w-4" />
      Export FIT
    </button>
  );
}
